import { z } from 'zod';
import { apiEnvelope } from '../envelope';
import { careAppointmentSlotsDataSchema } from '../api/care-scheduling';
import { telemedicineCounsellorKeySchema } from '../api/telemedicine';
import { careTeamSecondaryPresentationSchema } from './care-team-presentation';

/** Shared display fields only; response readers strip future fields at every object boundary. */
export const careProfessionalPresentationSchema = careTeamSecondaryPresentationSchema
  .pick({ name: true, initials: true, photoUrl: true })
  .strip();
export type CareProfessionalPresentation = z.infer<typeof careProfessionalPresentationSchema>;

export const careChatParticipantPresentationParamsSchema = z
  .object({
    conversationId: z.string().uuid(),
    participantId: z.string().uuid(),
  })
  .strict();
export const careChatParticipantPresentationDataSchema = z.object({
  ...careChatParticipantPresentationParamsSchema.shape,
  clinician: careProfessionalPresentationSchema.nullable(),
});
export type CareChatParticipantPresentationData = z.infer<
  typeof careChatParticipantPresentationDataSchema
>;
export const careChatParticipantPresentationResponseSchema = apiEnvelope(
  careChatParticipantPresentationDataSchema,
);

/** A separate route protects clients whose shipped slots response parser is strict. */
export const careAppointmentSlotsPresentationDataSchema = careAppointmentSlotsDataSchema
  .pick({ slots: true, durationMinutes: true, callType: true })
  .extend({
    specialist: careProfessionalPresentationSchema
      .extend({ specialistId: z.string().uuid() })
      .nullable(),
  });
export type CareAppointmentSlotsPresentationData = z.infer<
  typeof careAppointmentSlotsPresentationDataSchema
>;
export const careAppointmentSlotsPresentationResponseSchema = apiEnvelope(
  careAppointmentSlotsPresentationDataSchema,
);

export const careCallPresentationParamsSchema = z
  .object({ callSessionId: z.string().uuid() })
  .strict();
export const careCallPresentationDataSchema = z.object({
  ...careCallPresentationParamsSchema.shape,
  appointmentId: z.string().uuid(),
  counsellorKey: telemedicineCounsellorKeySchema,
  clinician: careProfessionalPresentationSchema.nullable(),
});
export type CareCallPresentationData = z.infer<typeof careCallPresentationDataSchema>;
export const careCallPresentationResponseSchema = apiEnvelope(careCallPresentationDataSchema);
